import { render, staticRenderFns } from "./imageInfo.vue?vue&type=template&id=522b1cb2&scoped=true&"
import script from "./imageInfo.vue?vue&type=script&lang=tsx&"
export * from "./imageInfo.vue?vue&type=script&lang=tsx&"
import style0 from "./imageInfo.vue?vue&type=style&index=0&id=522b1cb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522b1cb2",
  null
  
)

export default component.exports